import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import {alert, getLocalstorage, setLocalstorage} from '@/utils/utils'
import { getUserInfo } from '@/utils/common'

export const pathConstent = {
  GWC: 'gwc',
  QPLCP: 'qplcp'
}

export const jcContent = {
  JGQX: 'jgqx'
}

export const breadConstent = {
  HOME: '/',
  CATEGORY: 'category',
  PRODUCT: 'product',
  DETAIL: 'detail',
  NEWS: '/news',
  SUPPORT: '/support',
  CONTACTUS: '/contactus',
  DISTRIBUTOR: '/dealer/distributor',
  BRANDSTORY: '/aboutus/companyoverview',
  MEDELIPARK: '/aboutus/medelipark',
  TEAM: '/aboutus/team',
  TECHNOLOGY: '/aboutus/technology',
}

const Context = createContext<{
  userInfo: any
  baseInfo: any
  updateUserInfo: (data: any) => void
  updateBaseInfo: () => void
  clear: () => void
  breads: any[]
  setBreasds: (data: any[]) => void
}>({
  userInfo: {},
  baseInfo: {},
  updateUserInfo() {},
  updateBaseInfo() {},
  clear() {},
  breads: [],
  setBreasds() {}
})

// 将权限树转为一维数组
const transformQx = (items) => {
  if(!items) {
    return []
  }
  let res = items.map(item => ({
    ...item,
    // 如果存在子节点，则当前节点为目录，将地址清空
    hmtzdz: item.children && item.children.length > 0 ? null : item.hmtzdz,
    children: null
  }))
  items.forEach((item) => {
    res = [...res, ...transformQx(item.children)]
  })
  return res
}

export const UserInfoProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({})
  const [baseInfo, setBaseInfo] = useState<any>({})
  const [done, setDone] = useState(false)
  const [breads, setBreasdsCore] = useState([])

  // 清空登录
  const clear = useCallback(() => {
    setBaseInfo({})
    setUserInfo({})
    setLocalstorage('userinfo', null)
  }, [])

  // 更新基本数据
  const updateBaseInfo = useCallback(async() => {
    // const res = await api.getCurrentUser()
    // if(res && res.userid) {
    //   if(res.userid === "-1"){
    //     alert("提示信息",res.msg,  () => {
    //       clear()
    //       window.location.reload()
    //     })
    //     return
    //   }
    //   // 更新本地缓存登录数据到状态
    //   const userInfo = getLocalstorage('userinfo')
    //   setUserInfo(userInfo)
    //   // 更新用户数据
    //   setBaseInfo({
    //     ...res,
    //     webqxList: res.qx && res.qx.webqx ? transformQx(JSON.parse(res.qx.webqx)) : [],
    //     ppqxList: res.qx && res.qx.ppqx ? transformQx(JSON.parse(res.qx.ppqx)) : [],
    //     jcqx: res.qx && res.qx.jcqx ? JSON.parse(res.qx.jcqx) : {}
    //   })
    //   setDone(true)
    // }else {
    //   alert("提示信息",res && res.msg || '获取用户信息失败',  () => {
    //     clear()
    //     window.location.reload()
    //   })
    // }
  }, [clear])

  const updateUserInfo = useCallback(async(data) => {
    setUserInfo(data)
    setLocalstorage('userinfo', data)
    updateBaseInfo()
  }, [updateBaseInfo])

  useEffect(() => {
    const userInfo = getLocalstorage('userinfo')
    setUserInfo(userInfo)
    if(userInfo) {
      setDone(true)
      // updateBaseInfo()
    } else {
      setDone(true)
    }
  }, [updateBaseInfo])

  // 更新breads
  const setBreasds = useCallback((data: any[]) => {
    setBreasdsCore(data.map((r) => ({
      ...r,
      title: r.title && r.title.toUpperCase() || ''
    })))
  }, [])

  return (
    <Context.Provider value={{ breads, baseInfo, userInfo, setBreasds, updateUserInfo, updateBaseInfo, clear }}>
      {done && children}
    </Context.Provider>
  );
}

export const useUserInfoContext = () => {
  return useContext(Context)
}

export default Context